/**
 * Collection AJAX Pagination
 * 点击 .pagination 里的分页链接时，AJAX 替换产品网格，不整页刷新
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-type="collection-template"]';
  var PRODUCTS_SELECTOR = '[data-collection-products]';
  var PAGINATION_SELECTOR = '.pagination';
  var LOADING_CLASS = 'is-loading';

  function getScrollTarget(section) {
    var stickyBar = section.querySelector('[data-collection-sticky-bar]');
    var headerH = (window.theme && window.theme.readHeights)
      ? window.theme.readHeights().stickyHeaderHeight
      : 0;
    var barH = stickyBar ? stickyBar.offsetHeight : 0;
    var rectTop = section.querySelector(PRODUCTS_SELECTOR).getBoundingClientRect().top;
    return rectTop + window.pageYOffset - headerH - barH - 10;
  }

  function fetchPage(url, section) {
    var sectionId = section.dataset.sectionId;
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);

    section.classList.add(LOADING_CLASS);
    window.scrollTo({ top: getScrollTarget(section), behavior: 'smooth' });

    fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(PRODUCTS_SELECTOR);
        var oldGrid = section.querySelector(PRODUCTS_SELECTOR);
        if (newGrid && oldGrid) {
          oldGrid.innerHTML = newGrid.innerHTML;
        }

        var newCount = doc.querySelector('[data-products-count]');
        var oldCount = section.querySelector('[data-products-count]');
        if (newCount && oldCount) oldCount.innerHTML = newCount.innerHTML;

        // 更新地址栏（去掉 section_id）
        var clean = new URL(url, window.location.origin);
        history.pushState({ ajaxPage: true }, '', clean.pathname + clean.search);

        section.classList.remove(LOADING_CLASS);
        document.dispatchEvent(new CustomEvent('theme:collection:paginated', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[ajax pagination]', err);
        section.classList.remove(LOADING_CLASS);
        window.location.href = url; // 失败退化为整页刷新
      });
  }

  // 事件委托：全站级别，避免容器被替换后失效
  document.addEventListener('click', function (e) {
    var link = e.target.closest(PAGINATION_SELECTOR + ' a');
    if (!link) return;

    var section = link.closest(SECTION_SELECTOR);
    if (!section) return;

    // 只处理同域链接
    if (link.hostname && link.hostname !== window.location.hostname) return;

    e.preventDefault();
    fetchPage(link.href, section);
  });

  // 浏览器前进后退
  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.ajaxPage) return;
    var section = document.querySelector(SECTION_SELECTOR);
    if (section) fetchPage(window.location.href, section);
  });
})();